var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomebaseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9498 15.4723H0.214008C0.0565033 15.4723 -0.0484997 15.6373 0.0227523 15.7798L0.99403 17.7261C1.17404 18.0861 1.5453 18.3148 1.94656 18.3148H26.2098C26.6148 18.3148 26.9823 18.0861 27.1623 17.7261L28.1336 15.7798C28.2048 15.6373 28.0998 15.4723 27.9423 15.4723H27.9498Z",
    fill: "#81FEB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88929 23.2012C10.2943 23.7075 10.9056 24 11.5543 24H16.6095C17.2582 24 17.8695 23.7037 18.2745 23.2012L19.0545 22.2262H9.10551L9.88554 23.2012H9.88929Z",
    fill: "#81FEB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04415 20.6174C5.35916 21.1724 5.94792 21.5137 6.58544 21.5137H21.5784C22.2159 21.5137 22.8047 21.1724 23.1197 20.6174L24.0309 19.0236H4.13287L5.04415 20.6174Z",
    fill: "#81FEB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7397 2.8419C24.7397 2.74064 24.6872 2.64689 24.601 2.59814L20.2658 0.0293148C20.1233 -0.0531875 19.9433 0.0480654 19.9433 0.21307V14.7635H24.7397V2.8419Z",
    fill: "#81FEB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22049 4.38694C8.22049 4.22943 8.09298 4.10193 7.93548 4.10193H7.44046V3.67442C7.44046 3.51691 7.31296 3.38941 7.15546 3.38941H6.19543V2.89065C6.19543 2.77439 6.10168 2.67689 5.98167 2.67689H5.69666C5.58041 2.67689 5.48291 2.77064 5.48291 2.89065V3.38941H4.52288C4.36538 3.38941 4.23787 3.51691 4.23787 3.67442V4.10193H3.70161C3.5441 4.10193 3.4166 4.22943 3.4166 4.38694V14.7635H8.21299V4.38694H8.22049Z",
    fill: "#81FEB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2346 6.517C19.2346 6.3595 19.107 6.23199 18.9495 6.23199H18.522V5.80448C18.522 5.64698 18.3945 5.51947 18.237 5.51947H16.317C16.1595 5.51947 16.032 5.64698 16.032 5.80448V6.23199H15.6044C15.4469 6.23199 15.3194 6.3595 15.3194 6.517V14.7597H19.2271V6.517H19.2346Z",
    fill: "#81FEB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6144 10.6384C14.6144 10.5484 14.5732 10.4659 14.5019 10.4096L11.9856 8.51956C11.8581 8.42581 11.6856 8.42581 11.5581 8.51956L9.04176 10.4096C8.97051 10.4621 8.92926 10.5484 8.92926 10.6384V14.7597H14.6144V10.6384Z",
    fill: "#81FEB7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomebaseLogo);
export default __webpack_public_path__ + "static/media/homebase-logo.0b7e1aac9a96f04a86b3ea59fd39f68e.svg";
export { ForwardRef as ReactComponent };